<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-comment-dots</v-icon>
      <span class="ml-2 title">Mensaje</span>
    </v-card-title>
    <v-card-text>
      <v-text-field
        v-model="value.titulo"
        label="Título del mensaje"
        :error-messages="errTitulo"
      ></v-text-field>
      <v-textarea
        v-model="value.mensaje"
        label="Mesaje"
        :error-messages="errMensaje"
      ></v-textarea>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="value.fecha_inicio"
            label="Fecha de inicio"
            type="datetime-local"
            :error-messages="errFechaInicio"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="value.fecha_fin"
            label="Fecha de finalización"
            type="datetime-local"
            :error-messages="errFechaFin"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer />
      <v-btn color="primary" :loading="loading" @click="saveMensaje()">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dayjs from 'dayjs'
import { required } from 'vuelidate/lib/validators'
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          titulo: '',
          mensaje: '',
          fecha_inicio: '',
          fecha_fin: ''
        }
      }
    },
    update: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    errTitulo () {
      const errs = []
      if (!this.$v.value.titulo.$dirty) return errs
      !this.$v.value.titulo.required && errs.push('El título es requerido')
      return errs
    },
    errMensaje () {
      const errs = []
      if (!this.$v.value.mensaje.$dirty) return errs
      !this.$v.value.mensaje.required && errs.push('El mensaje es requerido')
      return errs
    },
    errFechaInicio () {
      const errs = []
      if (!this.$v.value.fecha_inicio.$dirty) return errs
      !this.$v.value.fecha_inicio.required && errs.push('La fecha de inicio es requerida')
      return errs
    },
    errFechaFin () {
      const errs = []
      if (!this.$v.value.fecha_fin.$dirty) return errs
      !this.$v.value.fecha_fin.required && errs.push('La fecha de finalización es requerida')
      return errs
    }
  },
  methods: {
    saveMensaje () {
      this.$v.value.$touch()
      if (!this.$v.value.$invalid && this.validateFechas()) {
        if (!this.update) {
          this.insertMensaje()
        } else {
          this.updateMensaje()
        }
      }
    },
    async insertMensaje () {
      this.loading = true
      await this.$http.mensajes.post('', this.value)
      this.value = {
        titulo: '',
        mensaje: '',
        fecha_inicio: '',
        fecha_fin: ''
      }
      this.$v.value.$reset()
      this.loading = false
      this.$emit('saved')
    },
    async updateMensaje () {
      this.loading = true
      const data = {
        titulo: this.value.titulo,
        mensaje: this.value.mensaje,
        fecha_inicio: this.value.fecha_inicio,
        fecha_fin: this.value.fecha_fin
      }
      await this.$http.mensajes.put(`/${this.value.id}`, data)
      this.loading = false
      this.$emit('saved')
    },
    validateFechas () {
      if (dayjs(this.fecha_inicio).isBefore(this.fecha_fin)) {
        return true
      }
      window.alert('Las fechas no son correctas')
      return false
    }
  },
  validations: {
    value: {
      titulo: { required },
      mensaje: { required },
      fecha_inicio: { required },
      fecha_fin: { required }
    }
  }
}
</script>
